import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Menu } from "@mui/material";
import ManagePassLink from "./ManagePassLink";
import PassMenuItem from "./PassMenuItem";
const PassMenuList = (param)=>{
    let { anchorEl , menuWidth , passes , onPassSelect , selectedId , ...rest } = param;
    return /*#__PURE__*/ _jsxs(Menu, {
        ...rest,
        anchorEl: anchorEl,
        sx: {
            // NOTE: HandoutPassSectionModal과 중첩시 뒤로 밀리지 않도록 2008로 설정
            // HandoutPassSectionModal의 depth는 1007이지만, 이 모달이 쓰는 common/Overlay의 StyledOverlay는 depth + 1000을 z-index로 설정하여 2007이 됨
            zIndex: 2008
        },
        slotProps: {
            paper: {
                sx: {
                    ...menuWidth && {
                        width: menuWidth
                    },
                    borderRadius: "6px",
                    border: "1px solid",
                    borderColor: "grey.100",
                    boxShadow: "0px 4px 12px 0px rgba(0, 0, 0, 0.08), 0px 4px 8px 0px rgba(0, 0, 0, 0.04);",
                    mt: 0.5,
                    maxHeight: "400px"
                }
            }
        },
        children: [
            passes.map((pass)=>{
                /*#__PURE__*/ return _jsx(PassMenuItem, {
                    passContent: pass,
                    isSelected: selectedId === pass.id,
                    onClick: ()=>{
                        return onPassSelect === null || onPassSelect === void 0 ? void 0 : onPassSelect(pass);
                    }
                }, pass.id);
            }),
            /*#__PURE__*/ _jsx(ManagePassLink, {})
        ]
    });
};
export default PassMenuList;
